import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { supabase } from '../supabase'

const NAVY = '#0B1F3A'
const TEAL = '#2dd4b0'

function PaymentResult({ type }) {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const tran_id = searchParams.get('tran_id')
  const [payment, setPayment] = useState(null)

  useEffect(() => {
    if (tran_id) {
      supabase.from('subscription_payments').select('*').eq('tran_id', tran_id).single()
        .then(({ data }) => setPayment(data))
    }
    // Auto-redirect after 5s
    const t = setTimeout(() => navigate('/dashboard'), 5000)
    return () => clearTimeout(t)
  }, [tran_id, navigate])

  const isSuccess = type === 'success'
  const isFail    = type === 'fail'
  const isCancel  = type === 'cancel'

  return (
    <div style={{ minHeight: '100vh', background: '#F7F9FC', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', fontFamily: 'Space Grotesk, sans-serif' }}>
      <div style={{ background: '#FFFFFF', borderRadius: '20px', padding: '40px 36px', maxWidth: '440px', width: '100%', textAlign: 'center', boxShadow: '0 8px 40px rgba(0,0,0,0.08)' }}>

        <div style={{ fontSize: '52px', marginBottom: '16px' }}>
          {isSuccess ? '✅' : isFail ? '❌' : '↩️'}
        </div>

        <div style={{ fontSize: '22px', fontWeight: 800, color: NAVY, marginBottom: '8px' }}>
          {isSuccess ? 'Payment confirmed!' : isFail ? 'Payment failed' : 'Payment cancelled'}
        </div>

        <div style={{ fontSize: '13.5px', color: '#6B7A90', lineHeight: 1.7, marginBottom: '24px' }}>
          {isSuccess
            ? 'Your subscription is now active. Welcome to ' + (payment?.plan_label || 'PageConnect') + '!'
            : isFail
            ? 'Your payment could not be processed. No charge was made. Please try again or contact support.'
            : 'You cancelled the payment. No charge was made.'}
        </div>

        {isSuccess && payment && (
          <div style={{ background: '#F0FDF4', borderRadius: '12px', padding: '14px 16px', marginBottom: '20px', border: '1px solid #BBF7D0' }}>
            <table style={{ width: '100%' }}>
              <tbody>
                {[
                  ['Plan', payment.plan_label],
                  ['Billing', payment.billing_period === 'annual' ? 'Annual' : 'Monthly'],
                  ['Amount', (payment.currency === 'bdt' ? '৳' : '$') + Number(payment.amount).toLocaleString()],
                  ['Transaction', payment.tran_id],
                ].map(([k, v]) => (
                  <tr key={k}>
                    <td style={{ fontSize: '12px', color: '#6B7A90', padding: '3px 0', textAlign: 'left' }}>{k}</td>
                    <td style={{ fontSize: '12px', fontWeight: 600, color: NAVY, padding: '3px 0', textAlign: 'right' }}>{v}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <button onClick={() => navigate('/dashboard')}
          style={{ width: '100%', padding: '13px', borderRadius: '12px', background: isSuccess ? TEAL : NAVY, border: 'none', fontSize: '14px', fontWeight: 700, color: isSuccess ? NAVY : '#FFFFFF', cursor: 'pointer', fontFamily: 'Space Grotesk, sans-serif', marginBottom: '10px' }}>
          {isSuccess ? 'Go to dashboard →' : 'Back to dashboard'}
        </button>

        {(isFail || isCancel) && (
          <button onClick={() => navigate('/pricing')}
            style={{ width: '100%', padding: '12px', borderRadius: '12px', background: 'transparent', border: '1px solid #E5E7EB', fontSize: '13px', fontWeight: 600, color: '#6B7A90', cursor: 'pointer', fontFamily: 'Space Grotesk, sans-serif' }}>
            Try again
          </button>
        )}

        <div style={{ fontSize: '11px', color: '#D1D5DB', marginTop: '14px' }}>
          Redirecting to dashboard in 5 seconds...
        </div>
      </div>
    </div>
  )
}

export default PaymentResult